import { render } from "./Muster15Form.vue?vue&type=template&id=46a61fc6"
import script from "./Muster15Form.vue?vue&type=script&lang=js"
export * from "./Muster15Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__